<template>
  <div
    v-if="!useNewEditor"
    class="email-preview"
    :class="`email-preview${isStep ? '--in-step' : '--in-template'}`"
  >
    <CmHtmlPreview :preview="emailPreview" />
    <div v-if="!isStep" class="email-preview__image">
      <iframe
        id="preview"
        :srcdoc="emailPreview"
        width="500px"
        height="100%"
        frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import CmHtmlPreview from "@/components/library/CmHtmlPreview.vue";
import methods from "@/components/nodes/previewMethods.js";
import { mapGetters } from 'vuex';

export default {
  name: "EmailPreview",
  mixins: [methods],
  components: {
    CmHtmlPreview
  },
  computed: {
    ...mapGetters(["useNewEditor"]),
    
    emailPreview() {
      return this.template.Template.replace(/\[%Картинка%]/gi, "/no_image.png");
    }
  }
}
</script>

<style lang="scss">
.email-preview {
  overflow: hidden;
  &__image {
    background: #eeeeee;
    width: 500px;
    height: 666px;
    margin-top: 30px;
  }
  &--in-step {
    width: 100%;
    .cm-html-preview {
      display: flex;
      justify-content: center;
    }
  }
  &--in-template {
    width: 500px;
    .cm-html-preview {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}
</style>